import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TranscriptionService {
  private readonly apiUrl = environment.WO_API_URL;
  private cancelSubject: Subject<void> | null = null;

  constructor(private http: HttpClient) {}

  getTranscription(formData: FormData) {
    const access_token = localStorage.getItem('access_token') ?? '';
    this.cancelSubject = new Subject<void>();
    let request = this.http
      .post(`${this.apiUrl}/audio-transcription`, formData, {
        observe: 'response',
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .pipe(takeUntil(this.cancelSubject));
    return request;
  }

  cancelTranscription() {
    if (this.cancelSubject) {
      this.cancelSubject.next();
      this.cancelSubject.complete();
    }
    this.cancelSubject = null;
  }
}
